import { render, staticRenderFns } from "./SoccerTipsters.vue?vue&type=template&id=77909957&"
import script from "./SoccerTipsters.vue?vue&type=script&lang=js&"
export * from "./SoccerTipsters.vue?vue&type=script&lang=js&"
import style0 from "./SoccerTipsters.vue?vue&type=style&index=0&id=77909957&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports